import React, { ReactElement } from 'react'
import SectionContainer from '../SectionContainer'
import RoutersIcon from 'images/integrations/routers.svg'
import ItemContainer from '../ItemContainer'
import AsusMerlin from 'images/integrations/routers/asus-merlin.svg'
import DdWrt from 'images/integrations/routers/dd-wrt.svg'
import Firewalla from 'images/integrations/routers/firewalla.svg'
import FreshTomato from 'images/integrations/routers/fresh-tomato.svg'
import OpenWRT from 'images/integrations/routers/open-wrt.svg'
import Gargoyle from 'images/integrations/routers/gargoyle.svg'
import PfSense from 'images/integrations/routers/pf-sense.svg'
import OPNsense from 'images/integrations/routers/opn-sense.svg'
import VyOS from 'images/integrations/routers/vy-os.svg'
import MikroTikRouterOS from 'images/integrations/routers/router-os.svg'
import EdgeOSUbiquiti from 'images/integrations/routers/edge-os.svg'
import Synology from 'images/integrations/routers/synology.svg'

export default function RoutersSection(): ReactElement {
  return (
    <SectionContainer isOrangeBlur sectionIcon={RoutersIcon} title="Routers">
      <ItemContainer
        icon={AsusMerlin}
        title="Asus Merlin"
        learnMorePath="asus-router-setup#asus-routers"
      />
      <ItemContainer icon={DdWrt} title="DD-WRT" learnMorePath="dd-wrt-router-guide" />
      <ItemContainer icon={Firewalla} title="Firewalla" />
      <ItemContainer
        icon={FreshTomato}
        title="Fresh Tomato"
        learnMorePath="freshtomato-router-guide"
      />
      <ItemContainer icon={OpenWRT} title="OpenWRT" />
      <ItemContainer icon={Gargoyle} title="Gargoyle" />
      <ItemContainer icon={PfSense} title="pfSense" />
      <ItemContainer icon={OPNsense} title="OPNsense" />
      <ItemContainer icon={VyOS} title="VyOS" />
      <ItemContainer icon={MikroTikRouterOS} title="MikroTik RouterOS" />
      <ItemContainer icon={EdgeOSUbiquiti} title="EdgeOS (Ubiquiti)" />
      <ItemContainer icon={Synology} title="Synology" />
    </SectionContainer>
  )
}
